const state = {
    error: null
};

export default state;
